import { SHIPPING_TYPE } from "constants/order";
import {
  useDetailBus,
  useDetailCustomer,
  useDetailRunnerUser,
  useDetailTransport,
  useDistricts,
  useListShippingUnitAll,
  useProvinces,
  useWards,
} from "hooks";
import { useDetailOrderHistory, useOrderStatus } from "hooks/order/useOrder";
import OrderDetailChild from "pages/Orders/OrderDetail/OrderDetailChild/OrderDetailChild";
import OrderDetailForm from "pages/Orders/OrderDetail/OrderDetailForm/OrderDetailForm";
import OrderDetailHistory from "pages/Orders/OrderDetail/OrderDetailHistory/OrderDetailHistory";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { Button, Card, UncontrolledTooltip } from "reactstrap";

const initLocalitiesParams = () => {
  return {
    countryId: 1,
    type: 1,
    parent_code: "",
  };
};

const initRunnerDetailParams = {
  runnerId: null,
  run: false,
};

const initTransportParams = {
  transportId: "",
};
const initBusParams = {
  busId: "",
};
const initCustomerParams = {
  customerId: "",
};

const DetailOrderScan = props => {
  const {
    order,
    scanCode,
    printBarcode,
    scanSessionId,
    autoOpenReceiveBusChildBarcode,
    onAutoOpenReceiveBusChildConsumed,
    onScanFocusLockChange,
  } = props;
  const { addToast } = useToasts();

  // order detail history
  const {
    refetch: fetchOrderDetailHistory,
    data: history,
    isLoading: isHistoryLoading,
  } = useDetailOrderHistory({
    orderId: order?.id,
  });

  const { refetch: fetchOrderStatusList, data: orderStatusList } =
    useOrderStatus();

  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardParams, setWardParams] = useState(initLocalitiesParams);

  const [runnerParams, setRunnerParams] = useState(initRunnerDetailParams);

  const { data: provinces, refetch: refetchProvinces } =
    useProvinces(provinceParams);
  const { data: districts, refetch: refetchDistricts } =
    useDistricts(districtParams);
  const { data: wards, refetch: refetchWards } = useWards(wardParams);

  // get shipping type all
  const { data: shippingTypeAll, refetch: listShippingTypeAll } =
    useListShippingUnitAll();

  const [shipping, setShipping] = useState();
  const [transportParam, setTransportParam] = useState(initTransportParams);
  const [busParam, setBusParam] = useState(initBusParams);

  const [customerParams, setCustomerParams] = useState(initCustomerParams);

  const [isHCMOrder, setIsHCMOrder] = useState(false);

  useEffect(() => {
    if (provinceParams?.type === 1) refetchProvinces();
  }, [provinceParams, refetchProvinces]);

  useEffect(() => {
    if (districtParams?.type === 2) refetchDistricts();
  }, [districtParams, refetchDistricts]);

  useEffect(() => {
    if (wardParams?.type === 3) refetchWards();
  }, [wardParams, refetchWards]);

  // get runner by id
  const { data: runner, refetch: runnerDetail } =
    useDetailRunnerUser(runnerParams);

  useEffect(() => {
    if (runnerParams && runnerParams.run) runnerDetail();
  }, [runnerParams]);

  //shipping detail
  const onSuccessTransportDetail = data => {
    setShipping(data);
  };
  const onSuccessBusDetail = data => {
    setShipping(data);
  };

  const { refetch: transportDetail } = useDetailTransport(
    transportParam,
    onSuccessTransportDetail
  );

  const { refetch: busDetail } = useDetailBus(busParam, onSuccessBusDetail);

  useEffect(() => {
    if (transportParam?.transportId) transportDetail();
  }, [transportParam]);

  useEffect(() => {
    if (busParam?.busId) busDetail();
  }, [busParam, busDetail]);

  const { data: customer, refetch: fetch_detailCustomer } =
    useDetailCustomer(customerParams);

  useEffect(() => {
    if (customerParams?.customerId) fetch_detailCustomer();
  }, [customerParams, fetch_detailCustomer]);

  useEffect(() => {
    const isHCM = order?.shipping_type === SHIPPING_TYPE.RUNNER ? true : false;
    setIsHCMOrder(isHCM);

    //get runner by id
    const runner_id = order?.orderDelivery?.runner_id;
    if (runner_id) setRunnerParams({ runnerId: runner_id, run: true });

    // 3 is bus
    if (order?.orderDelivery?.shipping_type === 3)
      setBusParam({ busId: order?.orderDelivery?.bus_id });
    else if (order?.orderDelivery?.shipping_type === 2)
      // 2 is transport
      setTransportParam({ transportId: order?.orderDelivery?.transport_id });

    setCustomerParams(prev => ({
      ...prev,
      customerId: order?.customer_id,
    }));

    setDistrictParams(prev => ({ ...prev, type: 2 }));
    setWardParams(prev => ({ ...prev, type: 3 }));
    listShippingTypeAll();
    fetchOrderStatusList();
    fetchOrderDetailHistory();
  }, []);

  const printBarcodeHandle = (order, type = "order_code") => {
    const barcodeValue =
      type === "ref_code" ? order?.ref_code : order?.order_code;

    if (Boolean(order.is_transfer_order)) {
      //Đơn trung chuyển
      printBarcode({
        barcodeValue: barcodeValue,
        subLabel: order?.type === 2 ? order?.sender_name : order?.reciever_name, // đơn nhận thì in hub gửi, đơn trả thì in hub nhận ,
      });
    } else {
      // Đơn thường
      printBarcode({
        barcodeValue: barcodeValue,
        subLabel: order?.customer_name,
      });
    }
  };

  return (
    <div style={{ overflow: "auto", height: "100%" }}>
      <div
        className="d-flex fw-bold mt-1 scanrowInfoOrder"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "17px",
        }}
      >
        <div
          className="gap-5 d-flex scanrowcode"
          style={{
            fontStyle: "italic",
          }}
        >
          <div className="d-flex gap-1">
            Mã kiện:
            <div className="text-info">{scanCode} </div>
          </div>
          <div className="d-flex gap-1">
            Mã đơn:
            <div
              className="text-info"
              id="order_code_copy"
              style={{
                cursor: "pointer",
              }}
              onClick={e => navigator.clipboard.writeText(order?.order_code)}
            >
              {order?.order_code}
            </div>
            <UncontrolledTooltip placement="top" target={`order_code_copy`}>
              Copy
            </UncontrolledTooltip>
          </div>
          <div className="d-flex gap-1">
            Mã tham chiếu:
            <div
              className="text-info"
              id="ref_code_copy"
              style={{
                cursor: "pointer",
              }}
              onClick={e => navigator.clipboard.writeText(order?.ref_code)}
            >
              {order?.ref_code}
            </div>
            <UncontrolledTooltip placement="top" target={`ref_code_copy`}>
              Copy
            </UncontrolledTooltip>
          </div>
        </div>
        <div className="d-flex">
          <Button
            onClick={() => {
              if (!order?.order_code) {
                addToast("Không có mã kiện", {
                  appearance: "error",
                  autoDismiss: true,
                });
                return;
              }
              printBarcodeHandle(order);
            }}
            type="button"
            color="success"
            className="me-2 btn-label"
          >
            <i
              className="bx bxs-printer label-icon "
              title="In mã kiện"
              style={{
                fontSize: "28px",
              }}
            ></i>
            In mã kiện
          </Button>
          <Button
            onClick={() => {
              if (!order?.ref_code) {
                addToast("Không có mã tham chiếu", {
                  appearance: "error",
                  autoDismiss: true,
                });
                return;
              }
              printBarcodeHandle(order, "ref_code");
            }}
            type="button"
            color="info"
            className="me-2 btn-label"
          >
            <i
              className="bx bxs-printer label-icon "
              title="In mã tham chiếu"
              style={{
                fontSize: "28px",
              }}
            ></i>
            In mã tham chiếu
          </Button>
        </div>
      </div>
      <Card body className="">
        <OrderDetailForm
          orderScanInfo={order}
          data={order}
          orderStatusList={orderStatusList}
          provinces={provinces}
          districts={districts}
          wards={wards}
          shippingUnitType={shippingTypeAll}
          runner={runner}
          isHCMOrder={isHCMOrder}
          shipping={shipping}
          customer={customer}
          isHighlightCustomerName={customer && customer.code === "GSNEW"}
        />
      </Card>
      {order?.childs?.length > 0 || order?.is_receive_bus ? (
        <OrderDetailChild
          path={"manage-orders"}
          parent_id={order?.id}
          parent_code={order?.order_code}
          orderStatusList={orderStatusList}
          isReceiveBus={order?.is_receive_bus}
          parentStatus={order?.status}
          scanSessionId={scanSessionId}
          autoOpenBarcode={autoOpenReceiveBusChildBarcode}
          onAutoOpenConsumed={onAutoOpenReceiveBusChildConsumed}
          onScanFocusLockChange={onScanFocusLockChange}
        />
      ) : (
        <></>
      )}
      <OrderDetailHistory
        data={history}
        status={orderStatusList}
        isLoading={isHistoryLoading}
      />
    </div>
  );
};

DetailOrderScan.propTypes = {
  order: PropTypes.any,
  scanCode: PropTypes.any,
  printBarcode: PropTypes.any,
  scanSessionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  autoOpenReceiveBusChildBarcode: PropTypes.string,
  onAutoOpenReceiveBusChildConsumed: PropTypes.func,
  onScanFocusLockChange: PropTypes.func,
};

DetailOrderScan.defaultProps = {
  order: null,
  scanCode: null,
  printBarcode: null,
  // donutLabel: [],
};

export default DetailOrderScan;
